var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGoogle = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M16.192 7.635H9.15v2.783h4.133c-.083.69-.533 1.732-1.534 2.433-.634.443-1.485.75-2.599.75-1.984 0-3.668-1.309-4.268-3.116A4.6 4.6 0 0 1 4.632 9c0-.518.09-1.016.24-1.485.607-1.807 2.29-3.116 4.274-3.116 1.41 0 2.359.607 2.899 1.117L14.16 3.45C12.859 2.243 11.168 1.5 9.142 1.5a7.5 7.5 0 0 0-6.7 10.868 7.5 7.5 0 0 0 6.7 4.132c2.026 0 3.724-.668 4.966-1.815 1.417-1.309 2.235-3.232 2.235-5.516 0-.615-.05-1.065-.158-1.534z" }) }))); };
export default SvgGoogle;
